import { Component, Input } from '@angular/core';

@Component({
  selector: 'shared-filter-panel',
  templateUrl: 'filter-panel.component.html',
  styleUrls: ['./filter-panel.component.scss'],
  host: { class: 'filter-panel' },
})
export class SharedFilterPanelComponent {
  @Input() disableSpacer = false;
}
